/**
 * Tema claro/oscuro (Ola A del rediseño, 8-sep-2026).
 * Persistencia: localStorage 'flowex-theme' = 'dark' | 'light'. Default: light.
 * El tema vive como data-theme en <html>; el CSS de index.css hace el resto.
 */
import { useEffect } from 'react';

const KEY = 'flowex-theme';

export function getTheme() {
  try {
    const t = localStorage.getItem(KEY);
    return t === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyTheme(theme) {
  const t = theme === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-theme', t);
  try { localStorage.setItem(KEY, t); } catch { /* modo incognito */ }
  return t;
}

export function toggleTheme() {
  return applyTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

/** Llamar UNA vez al arrancar la app (antes del primer render, en main.jsx). */
export function initTheme() {
  document.documentElement.setAttribute('data-theme', getTheme());
}

/** Auth screens (login/register) are designed light. Keep html on light while mounted. */
export function useForceLightTheme() {
  useEffect(() => {
    const prev = document.documentElement.getAttribute('data-theme') || getTheme();
    document.documentElement.setAttribute('data-theme', 'light');
    return () => {
      const restore = prev === 'dark' ? 'dark' : getTheme();
      document.documentElement.setAttribute('data-theme', restore);
    };
  }, []);
}
